module.exports = __webpack_public_path__ + "static/media/apple.2d057c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple.png
// module id = 625
// module chunks = 0